import { render, staticRenderFns } from "./goods-abbreviation.vue?vue&type=template&id=3d530e10&scoped=true"
import script from "./goods-abbreviation.vue?vue&type=script&lang=js"
export * from "./goods-abbreviation.vue?vue&type=script&lang=js"
import style0 from "./goods-abbreviation.vue?vue&type=style&index=0&id=3d530e10&prod&lang=scss&scoped=true"
import style1 from "./goods-abbreviation.vue?vue&type=style&index=1&id=3d530e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d530e10",
  null
  
)

export default component.exports